import {
  ArrowIcon,
  CenterWrapper,
  ChatHeaderContainer,
  IconWrapper,
  LeftWrapper,
  LogoIcon,
  RightWrapper,
} from './styled';

import mobileBack from '../../assets/mobile-back.svg';

import { containerState } from '../../constant';

import close from '../../assets/closeChat.svg';

const ChatHeader = (props) => {
  const {
    device,
    chatConfig,
    toggleIcon,
    setToggleIcon,
    zoomWindow,
    setZoomWindow,
    container,
    setContainer,
    channel,
    setChannel,
    isHistory,
    agentDisabled,
    setMobileAgentDisabled,
    trainGetMessageCount,
    agentInput,
    setAgentInput,
  } = props;

  /**
   * 处理点击返回图标
   */
  const handleClickBack = () => {
    setContainer(containerState.CONTACT);
  };

  /**
   * 处理点击窗口缩放图标
   */
  const handleClickZoomWin = () => {
    setZoomWindow(!zoomWindow);
  };

  /**
   * 处理点击窗口关闭图标
   */
  const handleClickCloseIcon = () => {
    if (device === 'pc') {
      setToggleIcon(!toggleIcon);
      // if (trainGetMessageCount) {
      //   // 存储imChatSessionId 在结束回话的时候清楚
      //   trainGetMessageCount();
      // }
    }
    if (device === 'mobile') {
      props.endChat();
    }
  };

  /**
   * 处理点击转人工图标，移动端显示此图标
   */
  const handleClickToAgent = () => {
    /*if (channel === channelState.CONNECT) {
      return;
    }
    // 切换聊天渠道
    setChannel(channelState.CONNECT);*/
    console.log('点击转人工');
    setMobileAgentDisabled(true);
  };

  const buildElement = () => {
    /*if (device === 'mobile') {
      return (
        <ChatHeaderContainer $themecolor={chatConfig.chatThemeColor}>
          <LeftWrapper>
            <IconWrapper>
              {container !== containerState.CONTACT && !isHistory ? (
                <BackWrapper>
                  <img onClick={handleClickBack} src={mobileBack} alt="" />
                </BackWrapper>
              ) : (
                ''
              )}
            </IconWrapper>
            <TextWrapper $device={device}>{chatConfig.chatTitle}</TextWrapper>
          </LeftWrapper>
          <RightWrapper>
            {!isHistory &&
            container === containerState.CHAT_WIDGET &&
            agentDisabled &&
            (chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3') ? (
              <div onClick={handleClickToAgent}>
                {channel === channelState.KNOWLEDGE ? AgentIcon('#fff', 20, 20) : AgentIcon('#999', 20, 20)}
              </div>
            ) : (
              ''
            )}
          </RightWrapper>
        </ChatHeaderContainer>
      );
    } else {
      return (
        <ChatHeaderContainer $themecolor={chatConfig.chatThemeColor}>
          <LeftWrapper>
            <IconWrapper>
              {container !== containerState.CONTACT && !isHistory ? (
                <BackWrapper>
                  <img onClick={handleClickBack} src={mobileBack} alt="" />
                </BackWrapper>
              ) : (
                ''
              )}
              {container !== containerState.CONTACT_DETAIL ? (
                <LogoWrapper>
                  <img src={chatConfig.chatCompanyLogo} alt="" />
                </LogoWrapper>
              ) : (
                ''
              )}
            </IconWrapper>
            <TextWrapper $device={device}>{chatConfig.chatTitle}</TextWrapper>
          </LeftWrapper>
          <RightWrapper>
            <img src={zoomWindow ? shousuo : fangda} alt="" onClick={handleClickZoomWin} />
            <img src={close} alt="" onClick={handleClickCloseIcon} />
          </RightWrapper>
        </ChatHeaderContainer>
      );
    }*/
    if (device === 'mobile') {
      return (
        <ChatHeaderContainer $themecolor={chatConfig.chatThemeColor}>
          <LeftWrapper>
            {container !== containerState.CONTACT && !isHistory && !chatConfig.isVideoContainer ? (
              chatConfig.singleChat ? (
                ''
              ) : (
                <ArrowIcon>
                  <img onClick={handleClickBack} src={mobileBack} alt="" />
                </ArrowIcon>
              )
            ) : (
              ''
            )}
          </LeftWrapper>
          <CenterWrapper>{agentInput ? chatConfig.beTyping + '……' : ''}</CenterWrapper>
          <RightWrapper>
            {!isHistory &&
            container === containerState.CHAT_WIDGET &&
            agentDisabled &&
            (chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3') ? (
              <IconWrapper>
                {/* <div onClick={handleClickToAgent}>
                  {channel === channelState.KNOWLEDGE ? AgentIcon('#fff', 22, 22) : AgentIcon('#999', 22, 22)}
                </div> */}

                {chatConfig.singleChat ? (
                  ''
                ) : (
                  <div>
                    <img src={close} alt="" onClick={handleClickCloseIcon} />
                  </div>
                )}
              </IconWrapper>
            ) : container === containerState.CHAT_WIDGET && !chatConfig.isVideoContainer ? (
              chatConfig.singleChat ? (
                ''
              ) : (
                <IconWrapper>
                  <div>
                    <img src={close} alt="" onClick={handleClickCloseIcon} />
                  </div>
                </IconWrapper>
              )
            ) : (
              ''
            )}
          </RightWrapper>
        </ChatHeaderContainer>
      );
    } else {
      return (
        <ChatHeaderContainer $themecolor={chatConfig.chatThemeColor}>
          <LeftWrapper>
            {container !== containerState.CONTACT && !isHistory ? (
              chatConfig.singleChat ? (
                ''
              ) : (
                <ArrowIcon>
                  <img onClick={handleClickBack} src={mobileBack} alt="" />
                </ArrowIcon>
              )
            ) : (
              ''
            )}
            {container !== containerState.CONTACT_DETAIL ? (
              <LogoIcon>
                <img src={chatConfig.chatCompanyLogo} alt="" />
              </LogoIcon>
            ) : (
              ''
            )}
          </LeftWrapper>
          <CenterWrapper>{agentInput ? chatConfig.beTyping + '……' : ''}</CenterWrapper>
          <RightWrapper>
            {/*<img src={zoomWindow ? shousuo : fangda} alt="" onClick={handleClickZoomWin} />*/}
            {chatConfig.fullScreen ? '' : <img src={close} alt="" onClick={handleClickCloseIcon} />}
          </RightWrapper>
        </ChatHeaderContainer>
      );
    }
  };

  return <>{buildElement()}</>;
};

const AgentIcon = (color, width = 18, height = 18) => (
  <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00034 3.14258C7.57834 3.14258 8.85748 4.42172 8.85748 5.99972H8.00034C8.00033 5.60708 7.88475 5.22313 7.66801 4.89573C7.45127 4.56833 7.14295 4.31197 6.7815 4.15861C6.42004 4.00526 6.02144 3.96169 5.6354 4.03333C5.24935 4.10498 4.89293 4.28867 4.61057 4.56151C4.32821 4.83435 4.13241 5.18427 4.04758 5.56764C3.96275 5.951 3.99263 6.35086 4.13351 6.71736C4.27439 7.08385 4.52003 7.40078 4.83981 7.62861C5.15959 7.85645 5.53936 7.98512 5.93177 7.99858L6.00034 7.99972C7.81234 7.99972 9.3432 9.20458 9.83463 10.8569H8.92891C8.47177 9.68629 7.33291 8.85686 6.00034 8.85686C4.66777 8.85686 3.52891 9.68629 3.07177 10.8569H2.16605C2.33138 10.3045 2.61383 9.79432 2.99418 9.36103C3.37452 8.92773 3.84381 8.58153 4.37005 8.34601C3.99111 8.08324 3.68153 7.7325 3.46785 7.32386C3.25418 6.91522 3.14278 6.46086 3.1432 5.99972C3.1432 4.42172 4.42234 3.14258 6.00034 3.14258ZM6.00034 1.14258C8.11063 1.14258 9.8392 2.77686 9.98977 4.84858C10.2324 5.02687 10.4124 5.27725 10.5043 5.56397C10.5961 5.85069 10.595 6.1591 10.5011 6.44516C10.4073 6.73122 10.2254 6.98031 9.98155 7.15686C9.73768 7.33342 9.44427 7.42842 9.1432 7.42829L7.28605 7.42858C7.1961 7.54851 7.0707 7.6371 6.9276 7.6818C6.78451 7.7265 6.63097 7.72504 6.48875 7.67764C6.34653 7.63023 6.22282 7.53928 6.13517 7.41766C6.04751 7.29604 6.00034 7.14992 6.00034 7.00001C6.00034 6.85009 6.04751 6.70397 6.13517 6.58236C6.22282 6.46074 6.34653 6.36978 6.48875 6.32238C6.63097 6.27497 6.78451 6.27351 6.9276 6.31821C7.0707 6.36291 7.1961 6.4515 7.28605 6.57144L9.1432 6.57115C9.29475 6.57115 9.44009 6.51095 9.54726 6.40378C9.65442 6.29662 9.71463 6.15127 9.71463 5.99972C9.71463 5.84817 9.65442 5.70282 9.54726 5.59566C9.44009 5.4885 9.29475 5.42829 9.1432 5.42829V5.14258C9.1432 3.40686 7.73605 1.99972 6.00034 1.99972C4.26463 1.99972 2.85748 3.40686 2.85748 5.14258V5.42829C2.70593 5.42829 2.56059 5.4885 2.45342 5.59566C2.34626 5.70282 2.28605 5.84817 2.28605 5.99972C2.28605 6.15127 2.34626 6.29662 2.45342 6.40378C2.56059 6.51095 2.70593 6.57115 2.85748 6.57115V7.42829C2.55649 7.42833 2.26317 7.3333 2.01938 7.15676C1.7756 6.98022 1.59381 6.73119 1.49995 6.4452C1.40608 6.15921 1.40495 5.85089 1.49671 5.56422C1.58847 5.27755 1.76843 5.02719 2.01091 4.84886C2.16148 2.77686 3.89005 1.14258 6.00034 1.14258Z"
      fill={color}
    />
  </svg>
);
export default ChatHeader;
